import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import {TweenMax} from "gsap";
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isMobile:any;
  constructor(private deviceService: DeviceDetectorService) {
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit() {
  }

  openMenu() {
    TweenMax.to('.menu-mobile',0.6, {display:'block'});
  }

  closeMenu() {
    TweenMax.to('.menu-mobile',0.2, {display:'none'});
  }

  irHome() {
    this.closeMenu();
    location.href="./home";
  }

  irMiCuentaOnline() {
    //prod
    location.href="https://sucursalvirtual.metrogas.cl/ingreso/bienvenida";

    //qa
    //location.href="https://utilitygo-metrogascl-stage.widergydev.com/ingreso/bienvenida";
  }

  irSucursalVirtual() {
    //prod
    location.href="https://sucursalvirtual.metrogas.cl/ingreso/bienvenida";

    //qa
    //location.href="https://utilitygo-metrogascl-stage.widergydev.com/ingreso/bienvenida";
  }

  irMetrogas() {
    location.href="http://www.metrogas.cl/";
  }
}
